const breadCrumb = "Lançamento de Notas - Lançar Justificativas";

const routes = [
  {
    path: "/lancar-justificativa-ausencia-nota-aluno",
    name: "lancar-justificativa-ausencia-nota-aluno",
    meta: {
      allowedPermissions: ["lancamento_notas_turma_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancarJustificativaAusenciaNotaAluno/PermitirLancarJustificativaAusenciaNotaAlunoHome.vue"
      ),
  },
  {
    path: "/lancar-justificativa-ausencia-nota-aluno/:anoMatricula/:escolaId/:matriculaId/:periodoId",
    name: "lancar-justificativa-ausencia-nota-aluno-aluno",
    meta: {
      allowedPermissions: ["lancamento_notas_turma_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancarJustificativaAusenciaNotaAluno/LancarJustificativaAusenciaNotaAluno.vue"
      ),
  },
];

export default routes;
